import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import PropTypes from 'prop-types';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { allBloquesPedagogicosAction } from '../BloquesPedagogicosAction';

const SelectFieldBloquesPedagogicosComponent = ({
  onChange,
  id = 'select-bloquesPedagogicos',
  data,
  value,
  selects = [],
  required = false,
  error = false,
  isAll = true,
  isAllText = false,
  isEmpty = false,
}) => {
  const dispatch = Redux.useDispatch();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const bloquesPedagogicosStore = Redux.useSelector(
    (state) => state.bloquesPedagogicos,
  );

  const [items, setItems] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      if (!data && bloquesPedagogicosStore.all.length === 0) {
        await allBloquesPedagogicosAction(dispatch, {
          idEntidad: entidadesStore.activo.id,
        });
        setItems(bloquesPedagogicosStore.all);
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const _handlerSelects = () => {
    let items = [];
    if (selects.length > 0) {
      bloquesPedagogicosStore.all.forEach((se) => {
        const existSeletc = selects.some((item) => item.id === se.id);
        if (!existSeletc) items.push(se);
      });
      setItems(items);
    } else {
      if (data) {
        setItems(data);
      } else {
        setItems(bloquesPedagogicosStore.all);
      }
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  React.useEffect(() => _handlerSelects(), [selects]);

  return (
    <FormControl fullWidth size="small" required={required} error={error}>
      <InputLabel id={`label_${id}`}>
        {CONST.bloquesPedagogicos.label}
      </InputLabel>
      <Select
        id={CONST.ID}
        value={value}
        labelId={`label_${id}`}
        label={CONST.bloquesPedagogicos.label}
        onChange={(e) => onChange(e.target.value)}
      >
        {isEmpty ||
          (isAll && (
            <MenuItem key={`item_${id}_000`} value={null}>
              {isAll ? 'TODOS' : 'NINGUNO'}
            </MenuItem>
          ))}

        {isAllText && (
          <MenuItem key={`item_${id}_all`} value={'all'}>
            TODOS
          </MenuItem>
        )}
        {items.map((el, index) => {
          return (
            <MenuItem key={`item_${id}_${index}`} value={el.id}>
              {el.nombre}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

SelectFieldBloquesPedagogicosComponent.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SelectFieldBloquesPedagogicosComponent;
